/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

export function loadNotifyRecordsMetaData(metaData, method, userFlag) {
  const baseUrl = userFlag ==="user" ? "/notify" : "/masters";

  if (method === "post") {
    return api
      .post(`${baseUrl}/${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .post(`${baseUrl}/${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

/**
 * Load In-App Notifications
 */
export async function loadInAppNotificationDetails(payload) {
  return await api
    .post(`/notify/getnotificationinternal`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Create In-App Notification
 */
export async function createInAppNotificationDetails(payload) {
  return await api
    .post(`/notifications/pushnotificationinternal`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Update In-App Notification
 */
export async function updateInAppNotificationDetails(payload) {
  return await api
    .put(`/notifications/updatenotificationinternal`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Delete In-App Notification
 */
export async function deleteInAppNotificationDetails(payload) {
  return await api
    .post(`/notifications/deletenotificationinternal`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Load Push Notifications
 */
export async function loadPushNotificationDetails(payload) {
  return await api
    .post(`/notify/getnotification`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Create Push Notification
 */
export async function createPushNotificationDetails(payload) {
  return await api
    .post(`/pushnotificationinternal`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Update Push Notification
 */
export async function updatePushNotificationDetails(payload) {
  return await api
    .put(`/notifications/updatepushnotification`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

/**
 * Delete Push Notification
 */
export async function deletePushNotificationDetails(payload) {
  return await api
    .post(`/notifications/deletepushnotification`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  // In-App
  loadInAppNotificationDetails,
  createInAppNotificationDetails,
  updateInAppNotificationDetails,
  deleteInAppNotificationDetails,

  // Push
  loadPushNotificationDetails,
  createPushNotificationDetails,
  updatePushNotificationDetails,
  deletePushNotificationDetails,
  loadNotifyRecordsMetaData
};

export default remotes;
